import AttachmentOutlinedIcon from '@mui/icons-material/AttachmentOutlined';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import SwapCallsIcon from '@mui/icons-material/SwapCalls';
import type { ReactNode } from 'react';
import { useSwimlaneRootProps } from '@/components/ui/swimlane/context';
import type { ICard } from '@/components/ui/swimlane/types';
import { SubItems } from '../subitems/SubItems';

import { CardButton } from './CardButton';

type ButtonRowProps = Pick<
  ICard,
  | 'itemID'
  | 'rowID'
  | 'columnID'
  | 'linkedItems'
  | 'keyDates'
  | 'comments'
  | 'attachments'
  | 'subItems'
> & {
  actionsExpanded: boolean;
  getSubItemsButton: (canHaveLabel: boolean) => ReactNode | null;
  canAddSubItems?: boolean;
};

export function ButtonRow({
  itemID,
  rowID,
  columnID,
  linkedItems = 0,
  keyDates = 0,
  comments = 0,
  attachments = 0,
  subItems = [],
  actionsExpanded,
  getSubItemsButton,
}: ButtonRowProps) {
  const {
    actions,
    isPublicationMode,
    readOnly,
    isCompact,
    maxSubItemsPerItem,
    isSubItemFeaturesEnabled,
  } = useSwimlaneRootProps();
  const maxSubItems = maxSubItemsPerItem as number;
  const itemButtonActions = actions?.itemButtonActions || {};
  const { linkedItemsHandler, keyDatesHandler, commentsHandler, attachmentsHandler } =
    itemButtonActions;
  const subItemsButton = isSubItemFeaturesEnabled && !isCompact && getSubItemsButton(false);
  const showDetailsTemp = false && !isCompact; // details menu hidden for now, might be re-enabled later
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          flex: 1,
        }}
      >
        {showDetailsTemp && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CardButton
              label="Linked Items"
              count={linkedItems}
              icon={<SwapCallsIcon sx={{ fontSize: '14px' }} />}
              disabled={isPublicationMode && !linkedItems}
              onClick={() => linkedItemsHandler?.(itemID)}
            />
            <CardButton
              label="Key Dates"
              count={keyDates}
              icon={<EventOutlinedIcon sx={{ fontSize: '14px' }} />}
              disabled={isPublicationMode && !keyDates}
              onClick={() => keyDatesHandler?.(itemID)}
            />
            <CardButton
              label="Comments"
              count={comments}
              icon={<CommentOutlinedIcon sx={{ fontSize: '14px' }} />}
              disabled={isPublicationMode && !comments}
              onClick={() => commentsHandler?.(itemID)}
            />
            <CardButton
              label="Attachments"
              count={attachments}
              icon={<AttachmentOutlinedIcon sx={{ fontSize: '14px' }} />}
              disabled={isPublicationMode && !attachments}
              onClick={() => attachmentsHandler?.(itemID)}
            />
          </div>
        )}
        {subItemsButton}
      </div>
      {isSubItemFeaturesEnabled && (
        <SubItems
          itemID={itemID}
          columnID={columnID}
          rowID={rowID}
          expanded={actionsExpanded}
          subItems={subItems}
          // Temporarily force readOnly to true until we implement sub-item adding functionality
          // readOnly={readOnly}
          readOnly={readOnly || true}
          maxSubItemsPerItem={maxSubItems}
        />
      )}
    </div>
  );
}
